var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff715d;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 701.22,
    cy: 557.54,
    r: 289.49
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bubble_1",
    "data-name": "bubble 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 701.22,
    cy: 557.54,
    r: 289.49
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M778.14,349c-12.26-1-24.89-.53-36.41,3.79s-21.86,12.94-26.05,24.5c-6.11,16.86,2.06,36.11,14.83,48.7S760,446.15,775.7,454.75s31.49,19.06,39.92,34.89c10.07,18.91,7.87,41.62,8.79,63s7.43,45.65,26.73,55c13.38,6.44,30,3.55,42.3-4.68s21-21.09,27.07-34.61c34.39-76-10.28-164.43-80.68-201.29A161.37,161.37,0,0,0,778.14,349Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M804,683.93c-13.62,11.74-24,28.57-23.71,46.55s13.68,36.14,31.58,37.84c12.78,1.22,24.87-5.51,35.55-12.61,13.16-8.74,26-18.68,34.47-32s12.13-30.58,6-45.13C871.59,640,825.2,665.62,804,683.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects20);
export default __webpack_public_path__ + "static/media/objects-20.ae88b560b152c7e0aa07cace7fd980bf.svg";
export { ForwardRef as ReactComponent };